module.exports = __webpack_public_path__ + "static/img/accommodation-view-tabs02.3a434dfe.svg";